module.exports = __webpack_public_path__ + "img/icon-no-data-piechart.7640a647.svg";